import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

import { StaffShellPending } from "@/components/loading-skeleton"
import { StaffShell } from "@/components/staff-shell"
import { staffShellQueryOptions, viewerQueryOptions } from "@/lib/query-options"

export const Route = createFileRoute("/staff")({
  loader: async ({ context, location }) => {
    const viewer =
      await context.queryClient.ensureQueryData(viewerQueryOptions())

    if (
      !viewer ||
      (viewer.role !== "staff" && viewer.role !== "manager") ||
      !viewer.courseId
    ) {
      throw redirect({ to: "/login", search: { next: location.href } })
    }

    return context.queryClient.ensureQueryData(staffShellQueryOptions())
  },
  pendingComponent: StaffShellPending,
  component: StaffLayout,
})

function StaffLayout() {
  const { data } = useSuspenseQuery(staffShellQueryOptions())

  return (
    <StaffShell viewer={data.viewer} course={data.course}>
      <Outlet />
    </StaffShell>
  )
}
